<rr-icon name="user" class="default-company" *ngIf="
    !company.logo &&
    (
        !company.name ||
        company.name === ''
    )
  ">
</rr-icon>
<div class="default-company tiny" *ngIf="!company.logo && (company.name?.length)">
    {{ company.name![0] }}{{ company.name!.length > 1 ? company.name![1] : ''}}
</div>
<img class="logo" *ngIf="company.logo" [src]="backendServerUrl+ '/companies/logo/' + company.companyId"
    alt="Company Logo" />

